<template lang="pug">
  .card
    .card-body
      h5.card-title Shared link for Customer
      h6.card-subtitle This link can access in 15 day.
      //- .input-group
      label Web Link
      .input-group
        input(
          type="text"
          :value="linkToWeb"
          disabled
          ).form-control
        span.input-group-btn
          button(
            v-clipboard:copy="linkToWeb"
            v-clipboard:success="(e) => onCopy(e, 'web')"
            v-clipboard:error="onError"
            :disabled="isCopyingWeb"
          ).btn.btn-default {{ btnCopyTxtWeb }}
        span.input-group-btn
          a(
            :href="linkToWeb"
            target="_blank"
          ).btn.btn-primary Open Web Link
      hr
      label PDF Link
      .input-group
        input(
          type="text"
          :value="pdfLink"
          disabled
          ).form-control
        span.input-group-btn
          button(
            v-clipboard:copy="pdfLink"
            v-clipboard:success="(e) => onCopy(e, 'pdf')"
            v-clipboard:error="onError"
            :disabled="isCopyingPdf"
            ).btn.btn-default {{ btnCopyTxtPdf }}
        span.input-group-btn
          a(
            :href="pdfLink"
            target="_blank"
            ).btn.btn-primary Open PDF Link

      button(@click.prevent="$emit('onClose')").btn.btn-default Close


</template>

<script>
export default {
  props: {
    webLink: {
      type: String,
      default: 'Loram'
    },

    pdfLink: {
      type: String,
      default: 'Loram'
    }
  },

  data () {
    return {
      btnCopyTxtWeb: 'Copy Link',
      btnCopyTxtPdf: 'Copy Link',
      isCopyingWeb: false,
      isCopyingPdf: false
    }
  },

  computed: {
    linkToWeb () {
      return 'https://' + window.location.host + '/condo/pub/' + this.webLink
    }
  },

  mounted () {
    console.log(this.webLink)
  },

  methods: {
    onCopy: function (e, type) {
      // alert('You just copied: ' + e.text)
      if (type === 'web') this.btnCopyTxtWeb = 'Copied'
      else if (type === 'pdf') this.btnCopyTxtPdf = 'Copied'

      if (type === 'web') this.isCopyingWeb = true
      else if (type === 'pdf') this.isCopyingPdf = true

      setTimeout(() => {
        this.btnCopyTxtWeb = 'Copy Link'
        this.btnCopyTxtPdf = 'Copy Link'
        this.isCopyingWeb = false
        this.isCopyingPdf = false
      }, 2000)
    },

    onError: function (e) {
      alert('Failed to copy texts')
    }
  }
}
</script>

<style lang="less" scoped>
.card {
  background-color: white;
  width: 100%;
  height: 100%;

  &-body {
    padding: 10px 30px;

    // .btn {
    //   border-radius: 0;
    //   margin: 0 5px;
    // }

    .input-group {
      margin-bottom: 10px;
    }

    .form-control {
      // margin-bottom: 40px;
    }
  }

  &-title {
    font-size: 2rem;
  }

  &-subtitle {
    font-size: 1.5rem;
    margin-bottom: 30px;
  }
}

hr {
  margin: 15px 0;
}
</style>



// WEBPACK FOOTER //
// sharedLinkForCustomer.vue?4ed58e00